import { Component, inject, input, signal, WritableSignal } from "@angular/core";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { AppleConfigService } from "@bitwarden/web-vault/app/services/api/apple-config.service";
import { Clipboard } from "@capacitor/clipboard";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-ios-redemption-box",
  templateUrl: "./ios-redemption-box.component.html",
})
export class IosRedemptionBoxComponent {
  protected readonly deviceDetector = inject(DeviceDetectorService);
  private appleService: AppleConfigService = inject(AppleConfigService);
  private logService: LogService = inject(LogService);
  protected offerCode = input<string>("loading...");

  protected showTooltip: WritableSignal<boolean> = signal(false);

  async openRedemptionSheet() {
    await this.appleService.openRedemptionSheet();
  }

  async redeemAtPrefilledURL() {
    await this.appleService.openPrefilledRedeemUrl(this.offerCode());
  }

  async copyToClipboard() {
    if (this.offerCode()) {
      try {
        // Native write to iOS UIPasteboard
        await Clipboard.write({
          string: this.offerCode(),
        });

        this.showTooltip.set(true);
        // Reset the "Copied" state after 2 seconds
        setTimeout(() => this.showTooltip.set(false), 2000);
      } catch (error) {
        this.logService.error(`Native copy failed: ${error?.message ?? error}`);
      }
    }
  }
}
